import React from 'react';
import {
  FormControl,
  FormLabel,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ICON_POSITIONS } from '../constants/selectConstants';

export const IconSettings = ({ hasIcon, iconClass, iconPosition, setProp }) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="subtitle2">Icon Configuration</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormControlLabel
        control={
          <Checkbox
            checked={hasIcon}
            onChange={(e) => setProp(props => props.hasIcon = e.target.checked)}
          />
        }
        label="Show icon"
      />

      {hasIcon && (
        <>
          <FormControl fullWidth margin="normal">
            <FormLabel>Icon Class</FormLabel>
            <TextField
              value={iconClass || ''}
              onChange={(e) => setProp(props => props.iconClass = e.target.value)}
              size="small"
              placeholder="e.g., fas fa-globe"
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <FormLabel>Icon Position</FormLabel>
            <Select
              value={iconPosition || 'left'}
              onChange={(e) => setProp(props => props.iconPosition = e.target.value)}
              size="small"
            >
              {ICON_POSITIONS.map(pos => (
                <MenuItem key={pos.value} value={pos.value}>{pos.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </AccordionDetails>
  </Accordion>
);